const fadeInUp = (element) => {
  element.animate([
    { opacity: 0, transform: 'translateY(40px)' },
    { opacity: 1, transform: 'translateY(0)' }
  ], {
    duration: 200,
    delay: 1800,
    easing: 'ease-out',
    fill: 'forwards' // Keeps final state after animation
  });
};

document.addEventListener('DOMContentLoaded', () => {

  const observer = new MutationObserver((mutations, observer) => {
    const container = document.querySelector('.Accessify_Container');
   
    if (container) {
      container.style.visibility = 'hidden'; 
      
      const shadow = container.shadowRoot;
      const drawer = shadow.querySelector('.Accessify_Sidebar');
      const trigger = shadow.querySelector('.Accessify_Trigger_bottomLeft');
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      
      if (trigger) {
        // Set an ID to apply styles with higher specificity
        trigger.id = 'accessifyTrigger';
        const higherSpecificityTrigger = shadow.querySelector(`#${trigger.id}`);
        
        higherSpecificityTrigger.style.cssText = `
          left: ${mediaQuery.matches ? '100px' : '150px'} !important;
          bottom: 20px !important;
          filter: drop-shadow(rgba(7, 7, 7, 0.18) 0px 0px 30px);
          box-shadow: initial !important;
          -webkit-box-shadow: initial !important;
        `;
    
        const triggerSvg = higherSpecificityTrigger.querySelector('svg');
        if (triggerSvg) {
          triggerSvg.style.fill = '#000000';
        }
    
        const svgContainer = higherSpecificityTrigger.querySelector('div');
        if (svgContainer) {
          const iconSize = '60px';
    
          svgContainer.style.cssText = `width: ${iconSize} !important; height: ${iconSize} !important;`;
        }

        drawer.style.right = 'unset';
        container.style.visibility = 'visible';  
        observer.disconnect(); // Stop observing once the element is found and processed
      }
    }
  });
  
  // Start observing changes in the document
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});